import { put } from "../../../../apis/utils";
import { parseQueryString } from "../../../common/utils";

interface AnalyticsValidator {
  children: JSX.Element;
}
export const AnalyticsValidator = (
  props: AnalyticsValidator & RouterChildProps
) => {
  const { search } = props.history;
  let { merchant = null as number } = parseQueryString(search);

  put(`analytics/validate_merchant`, { merchant_id: merchant }).catch((e) => {
    if (e.status == 401) location.href = "/analytics";
  });
  return props.children;
};



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/AnalyticsValidator/index.tsx